import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const pageTitle = "Emergency Passport Bozeman, MT — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Fast Passport Center provides emergency, expedited, and same-day passport services in Bozeman, Montana. Serving Gallatin County, Belgrade, Big Sky, and surrounding areas. As fast as 24 hours — no Denver trip needed.";
const bozemanFaqs = [
  { q: "How do I get an expedited passport in Bozeman, Montana?", a: "Bozeman residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agency is in Denver, 400+ miles south via I-90/I-25." },
  { q: "Can BZN airport travelers use Fast Passport Center?", a: "Absolutely. BZN connects to major hubs for international travel. Fast Passport Center is the fastest passport option for BZN travelers — delivering to your Bozeman door before your departure date." },
];

export default function BozemanPage() {
  return (
    <>
      <CitySEOHead
        city="Bozeman"
        state="Montana"
        stateAbbr="MT"
        route="/cities/bozeman"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Bozeman, Montana"
        geoPosition="45.6770;-111.0429"
        keywords="expedited passport Bozeman, emergency passport Bozeman MT, same day passport Bozeman, fast passport Montana, passport renewal Bozeman, Gallatin County passport, BZN passport"
        faqs={bozemanFaqs}
        servicesSchema={[]}
        statePageName="Montana"
        statePageRoute="/states/montana"
        lastModified="2026-06-09"
        serviceAreaDesc="Expedited and emergency passport services for Bozeman, MT and Gallatin County. As fast as 24 hours. No Denver trip needed."
      />

      <div className="min-h-screen bg-white">
      <HeroSection />
      <StickyNav />
      <ProcessingTimeSection />
      <ServicesSection />
      <HowItWorksSection />
      <LocalAreaSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <FinalCTA />
      </div>
    </>
  );
}